<p class="mat-body">{{data.loremipsum}}</p>
<div mat-dialog-actions>
  <button mat-button (click)="onCancelClick()" *ngIf="data.actions.cancel">{{'Cancel' | translate}}</button>
  <button mat-button (click)="onOkClick()" *ngIf="data.actions.ok">{{'OK' | translate}}</button>
  <button mat-button (click)="onConfirmClick()" *ngIf="data.actions.confirm">{{'Confirm' | translate}}</button>
</div>
